export const validateZone = (availableZones, formProps) => {
  const selectedZones = formProps.values.zone;

  if (
    !selectedZones ||
    !Array.isArray(selectedZones) ||
    selectedZones.length === 0
  ) {
    return false;
  }

  // 1. Extraemos solo los IDs de lo que hay en el formulario (anuncio)
  const selectedIds = selectedZones.map((z) =>
    typeof z === "object" ? z._id : z,
  );

  // 2. Comprobamos si alguno de esos IDs existe en las opciones disponibles del departamento actual
  return availableZones.some((opt) => selectedIds.includes(opt._id));
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || value === "") return "0";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

export const checkIfIncludes = (origin, text) => {
  return origin
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .includes(
      text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase(),
    );
};
